export default __webpack_public_path__ + "static/media/Checkmark Illustration.7a5e42ce.png";